import { Component } from "@angular/core";
// import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { NavController,  Platform } from "@ionic/angular";
import { ConfigProvider } from "../../../providers/config/config";
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';//"@ionic-native/app-version/ngx";
import { HttpClient } from "@angular/common/http";
import { SettingsProvider } from "../../../providers/settings/settings";
import { Router } from "@angular/router";
import { NavigationService } from "src/providers/navigation/navigation.service";
declare var cordova:any;
/**
 * Generated class for the TextContactPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: "page-text-contact",
  templateUrl: "text-contact.html",
  styleUrls:['./text-contact.scss']
})
export class TextContactPage {
  contactUrl: string = "";
  buildInfo = {
    version: 1,
    lm: 0
  };
  pipeDateFormat = "dd.MM.yyyy";
  previousUrl:string;
  constructor(
    private platform: Platform,
    public navCtrl: NavController,
    public router:Router,
    private http: HttpClient,
    // private iab: InAppBrowser,
    private config: ConfigProvider,
    private settingsService: SettingsProvider,
    private navService:NavigationService
  ) {
    this.platform.ready().then(() => {
      this.settingsService.getActiveDateFormat().then(async date => {
        this.pipeDateFormat = date.pipeFormat;
        this.contactUrl = "mailto:" + (await this.config.config).contact.url;
        this.http
          .get('assets/data/buildInfo.json')
          .toPromise()
          .then((values: any) => {
            this.buildInfo = values;
          })
          .catch(error => {
            throw 'cannot get buildInfo.json';
          });
      });
      this.previousUrl = this.navService.getPreviousUrl();
      console.log('previousUrl', this.previousUrl)
      // this.appVersionService.getVersionCode().then(ver => {
      //   this.appVersion = ver + "";
      // });
    });
  }

  ionViewDidEnter() {
    console.log("ionViewDidEnter TextContactPage");
  }

  sendMail() {
    // let browser = this.iab.create(this.contactUrl);
    // browser.show();
    if (this.platform.is('cordova')) {
      const browser = cordova.InAppBrowser.open(this.contactUrl);
      browser.addEventListener('loadstop', () => {
        browser.show(); 
      });
      browser.addEventListener('exit', () => {
        console.log('InAppBrowser closed');
      });
    } else {
      window.open(this.contactUrl);
    }
  }
}
